import React, { useState, useEffect, useRef } from "react";
import { Link, Route, useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Logout from "./Logout";
import Signup from "./Signup";

import logo2 from "./../../images/logo.png";
import { isAuthenticated } from "../../redux/selectors/AuthSelectors";
import { connect, useDispatch } from "react-redux";
import Login from "./Login";
import BasicRoutes from "../../routers";
import PublicRouter from "../../routers/PublicRouter";
import { isMobileOrLaptop } from "../../services/CheckDevice";
import { getInitialsLettersOfString } from "../../services/GlobalStringOp";
import constants from "../../constants";
import {
  errorToast,
  getDataOnRequest,
  submitDataOnRequest,
} from "../../redux/actions/CommonActions";
import {
  addMinutes,
  getCurrentDateTime,
} from "../../services/GlobalCurrentDateAndTime";
import SwipeInModal from "../Element/SwipeInOrSwipeOut/SwipeInModal";
import SwipeOutModal from "../Element/SwipeInOrSwipeOut/SwipeOutModal";
import Swal from "sweetalert2";
import { redirectUrl } from "../../services/GlobalUrls";
import { jobSectorInvertList } from "../../services/JobTypeAndSectorGlobalList";

var bnr3 = require("./../../images/background/bg3.jpg");

const PageHeader = (props) => {
  // For Redirection Method - Start
  const [userProfileData, setUserProfileData] = useState({});
  const [userProgressBarData, setUserProgressBarData] = useState({});
  let getLocationSession = localStorage.getItem("redirectPathLocation");
  let currentActiveLocation = window.location.pathname;
  // For Redirection Method - End
  const [showSwipeInModal, setShowSwipeInModal] = useState(false);
  const [showSwipeOutModal, setShowSwipeOutModal] = useState(false);
  const [curretAssinmentIndividualData, setCurretAssinmentIndividualData] =
    useState([]);
  let imageRef = useRef(null);
  const dispatch = useDispatch();
  const [navBarOpen, setNavBarOpen] = useState(false);
  const [myCurrentAssignments, setMyCurrentAssignments] = useState([]);
  const [profilePic, setProfilePic] = useState(false);
  let history = useHistory();
  const [show, setShow] = useState(false);
  const [pageName, setPageName] = useState("/");
  const [roleId, setUserRoleId] = useState("");
  let userType = localStorage.getItem("user_job_type");
  localStorage.setItem(
    "loggedInUserAccessToken",
    props.userAuth.users_access_token,
  );
  localStorage.setItem("loggedInUserId", props.userAuth.users_id);
  localStorage.setItem(
    "users_identity_card_visible_to_candidate",
    props.userAuth.users_identity_card_visible_to_candidate,
  );
  localStorage.setItem("users_category", props.userAuth.users_category);
  localStorage.setItem("permanentUserStatus", props.userAuth.cnd_status);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  const onClick = (page) => {
    setPageName(page);
    history.push(page);
  };

  useEffect(() => {
    if (
      props.userAuth?.users_status &&
      props.userAuth?.users_status !== "Active"
    ) {
      Swal.fire({
        title: "Account Inactive - Contact Admin",
        icon: "info",
        text: `Dear Candidate, your account is currently inactive. Please contact the Admin for further assistance.`,
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        timer: 7000,
        timerProgressBar: true,
        didClose: () => {
          localStorage.clear();
          window.location.href = "";
        },
      });
    }
    setPageName(history.location.pathname);
    setUserRoleId(props.userAuth.users_role_id);
  }, [history.location.pathname, props.userAuth.users_role_id]);

  // Auto-logout when admin switches candidate type
  useEffect(() => {
    if (userProfileData && userProfileData.job_type) {
      const storedJobType = localStorage.getItem("user_job_type");
      if (storedJobType && storedJobType !== userProfileData.job_type) {
        Swal.fire({
          title: "Account Updated",
          text: "Your account type has been changed by the admin. Please log in again.",
          icon: "info",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        }).then(() => {
          localStorage.clear();
          window.location.href = "/login";
        });
      }
    }
  }, [userProfileData]);

  useEffect(() => {
    // sidebar open/close
    var Navicon = document.querySelector(".navicon");
    var sidebarmenu = document.querySelector(".myNavbar ");

    function toggleFunc() {
      sidebarmenu.classList.toggle("show");
      //   Navicon.classList.toggle('open');
    }

    Navicon.addEventListener("click", toggleFunc);

    // Sidenav li open close
    var navUl = [].slice.call(
      document.querySelectorAll(".navbar-nav > li > a, .sub-menu > li > a"),
    );
    for (var y = 0; y < navUl.length; y++) {
      navUl[y].addEventListener("click", function () {
        checkLi(this);
      });
    }

    function checkLi(current) {
      current.parentElement.parentElement
        .querySelectorAll("li")
        .forEach((el) =>
          current.parentElement !== el ? el.classList.remove("open") : "",
        );
      setTimeout(() => {
        current.parentElement.classList.toggle("open");
      }, 100);
    }
  }, []);

  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End

  // remind by later added by divya

  const onLogout = () => {
    localStorage.clear("loginUserDetails");
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('rtwReminderDismissed');
      sessionStorage.removeItem('identityDocReminderDismissed');
      sessionStorage.removeItem('dbsReminderDismissed');
    }
    window.location.href = "/";
  };

  // Swipe In/out Logic - Start
  useEffect(() => {
    if (
      props.userAuth.users_access_token &&
      props.myCurrentRunningAssignments
    ) {
      dispatch(
        getDataOnRequest(
          props.userAuth.users_access_token,
          "GetCurrentAssignmentsForSwipeInOrOut",
          "SET_MY_CURRENT_ASSIGNMENTS",
        ),
      );
    }
  }, [props.userAuth.users_access_token]);

  useEffect(() => {
    if (props.myCurrentRunningAssignments) {
      setMyCurrentAssignments(props.myCurrentRunningAssignments);
    }
  }, [props.myCurrentRunningAssignments]);

  const runSwipeInOrSwipeOutModalCall = (currentRunningShifts) => {
    const { currentDate, currentTime } = getCurrentDateTime(); // Get current date & time in London
    let isSwipeInVisible = false;
    let isSwipeOutVisible = false;
    let matchedAssignments = [];
    let myCurrentAssignments = [];
    if (currentRunningShifts) {
      myCurrentAssignments = currentRunningShifts
        // Remove rows that have both swipe_in_details and swipe_out_details
        .filter((item) => !(item.swipe_in_details && item.swipe_out_details))
        .sort((a, b) => {
          const getDateTimeRange = (item) => {
            const baseDate = item.cnd_assignment_availability_date;

            const start = new Date(
              `${baseDate}T${item.cnd_assignment_start_time}`,
            );
            let end = new Date(`${baseDate}T${item.cnd_assignment_end_time}`);

            // If end time is less than or equal to start time, it's next day
            if (end <= start) {
              end.setDate(end.getDate() + 1);
            }

            return { start, end };
          };

          const aTime = getDateTimeRange(a);
          const bTime = getDateTimeRange(b);

          if (aTime.start.getTime() === bTime.start.getTime()) {
            return aTime.end - bTime.end;
          }

          return aTime.start - bTime.start;
        });
    }
    if (myCurrentAssignments) {
      myCurrentAssignments.forEach((itemAssign) => {
        // LocalStorage Settings - Start
        let parsedData = {};
        const storedData = localStorage.getItem(
          "curretAssinmentIndividualData",
        );

        if (storedData) {
          try {
            parsedData = storedData ? JSON.parse(storedData) : {};
          } catch (error) {
            console.error("Error parsing JSON from localStorage:", error);
          }
        }

        const numberOfProperties = Object.keys(parsedData).length;
        // LocalStorage Settings - End
        const assignmentStartTime = itemAssign.cnd_assignment_start_time; // e.g., "20:00"
        const assignmentEndTime =
          !itemAssign.swipe_in_details &&
          itemAssign.cnd_assignment_end_time == "00:00"
            ? "23:59"
            : itemAssign.cnd_assignment_end_time; // e.g., "10:00"
        const assignmentType = itemAssign.cnd_assignment_work_shift_type_key; // "sleep_in" / "waking_night"

        // Convert dates properly
        const assignDateStart = new Date(
          itemAssign.cnd_assignment_availability_date,
        );
        // const assignDateEnd = new Date(itemAssign.cnd_assignment_end_date); //Old
        const assignDateEnd = new Date(
          itemAssign.cnd_assignment_end_time === "00:00"
            ? new Date(itemAssign.cnd_assignment_end_date).setDate(
                new Date(itemAssign.cnd_assignment_end_date).getDate() + 1,
              )
            : itemAssign.cnd_assignment_end_date,
        );

        const nowDate = new Date(currentDate);

        // Calculate additional time ranges
        const assignmentEndTimeAddMinutes = addMinutes(
          assignmentEndTime,
          itemAssign.swipe_in_details &&
            itemAssign.cnd_assignment_end_time == "23:30"
            ? 29
            : itemAssign.swipe_in_details &&
                itemAssign.cnd_assignment_end_time == "23:45"
              ? 14
              : 30,
        );
        const assignmentEndTimeMinus15 = addMinutes(assignmentEndTime, -15);

        // Convert times to HH:mm format
        const formattedNowTime = currentTime;
        const formattedStartTime = assignmentStartTime;
        const formattedEndTime = assignmentEndTime;
        const formattedEndTimeExtended = assignmentEndTimeAddMinutes;
        const formattedEndTimeMinus15 = assignmentEndTimeMinus15;

        // console.log("Swipe In Calling",nowDate, " - ", assignDateEnd, ' - ', formattedEndTime);
        // Check if this is an overnight shift (starts in PM, ends in AM)
        const isOvernightShift = formattedStartTime > formattedEndTime;

        // console.log(
        //   `Checking Shift: ${assignmentType}, Start: ${formattedStartTime}, End: ${formattedEndTime}`
        // );
        // console.log(
        //   `Current Date: ${nowDate.toDateString()}, Current Time: ${formattedNowTime}`
        // );

        if (isOvernightShift) {
          // Handle overnight shift properly
          if (nowDate.getTime() === assignDateStart.getTime()) {
            // Swipe In should work on the first date
            if (formattedNowTime >= formattedStartTime) {
              if (!itemAssign.swipe_in_details) {
                isSwipeInVisible = true;
                matchedAssignments.push({
                  ...itemAssign,
                  modalType: "swipe_in",
                });
              }
            }
          }

          if (nowDate.getTime() === assignDateEnd.getTime()) {
            // Swipe Out should work on the second date
            if (formattedNowTime <= formattedEndTimeMinus15) {
              if (!itemAssign.swipe_in_details) {
                isSwipeInVisible = true;
                matchedAssignments.push({
                  ...itemAssign,
                  modalType: "swipe_in",
                });
              }
            }
            if (
              formattedNowTime >= formattedEndTime &&
              formattedNowTime <= formattedEndTimeExtended
            ) {
              if (
                itemAssign.swipe_in_details &&
                (!itemAssign.swipe_out_details || numberOfProperties > 0)
              ) {
                isSwipeOutVisible = true;
                matchedAssignments.push({
                  ...itemAssign,
                  modalType: "swipe_out",
                });
              }
            }
          }
        } else {
          // Regular shifts
          if (nowDate.getTime() === assignDateStart.getTime()) {
            if (
              formattedNowTime >= formattedStartTime &&
              formattedNowTime <= formattedEndTimeMinus15
            ) {
              if (!itemAssign.swipe_in_details) {
                isSwipeInVisible = true;
                matchedAssignments.push({
                  ...itemAssign,
                  modalType: "swipe_in",
                });
              }
            }
          }

          if (nowDate.getTime() === assignDateEnd.getTime()) {
            if (
              formattedNowTime >= formattedEndTime &&
              formattedNowTime <= formattedEndTimeExtended
            ) {
              if (
                itemAssign.swipe_in_details &&
                (!itemAssign.swipe_out_details || numberOfProperties > 0)
              ) {
                isSwipeOutVisible = true;
                matchedAssignments.push({
                  ...itemAssign,
                  modalType: "swipe_out",
                });
              }
            }
          }
        }
      });

      // Ensure all matched assignments are saved
      if (matchedAssignments.length > 0) {
        setCurretAssinmentIndividualData(matchedAssignments);
        setShowSwipeInModal(
          isSwipeOutVisible ? isSwipeOutVisible : isSwipeInVisible,
        );
      }

      // Show modals accordingly
      // setShowSwipeInModal(
      //   isSwipeOutVisible ? isSwipeOutVisible : isSwipeInVisible
      // );
      // setShowSwipeInModal(isSwipeInVisible);
      // setShowSwipeOutModal(isSwipeOutVisible);
    }
  };

  // New Function Start
  //   const runSwipeInOrSwipeOutModalCall = (currentRunningShifts) => {
  //   const { currentDate, currentTime } = getCurrentDateTime(); // Get current date & time in London
  //   let isSwipeInVisible = false;
  //   let isSwipeOutVisible = false;
  //   let matchedAssignments = [];
  //   let myCurrentAssignments = [];

  //   if (currentRunningShifts) {
  //     myCurrentAssignments = currentRunningShifts
  //       .filter((item) => !(item.swipe_in_details && item.swipe_out_details))
  //       .sort((a, b) => {
  //         const dateA = new Date(`${a.cnd_assignment_end_date}T${a.cnd_assignment_start_time}`);
  //         const dateB = new Date(`${b.cnd_assignment_end_date}T${b.cnd_assignment_start_time}`);
  //         if (dateA.getTime() === dateB.getTime()) {
  //           const endTimeA = new Date(`${a.cnd_assignment_end_date}T${a.cnd_assignment_end_time}`);
  //           const endTimeB = new Date(`${b.cnd_assignment_end_date}T${b.cnd_assignment_end_time}`);
  //           return endTimeA - endTimeB;
  //         }
  //         return dateA - dateB;
  //       });
  //   }

  //   if (myCurrentAssignments) {
  //     myCurrentAssignments.forEach((itemAssign) => {
  //       let parsedData = {};
  //       const storedData = localStorage.getItem("curretAssinmentIndividualData");
  //       if (storedData) {
  //         try {
  //           parsedData = storedData ? JSON.parse(storedData) : {};
  //         } catch (error) {
  //           console.error("Error parsing JSON from localStorage:", error);
  //         }
  //       }
  //       const numberOfProperties = Object.keys(parsedData).length;

  //       const assignmentStartTime = itemAssign.cnd_assignment_start_time;
  //       const assignmentEndTime =
  //         !itemAssign.swipe_in_details &&
  //         itemAssign.cnd_assignment_end_time == "00:00"
  //           ? "23:59"
  //           : itemAssign.cnd_assignment_end_time;

  //       const assignDateStart = itemAssign.cnd_assignment_availability_date;
  //       const assignDateEnd =
  //         itemAssign.cnd_assignment_end_time === "00:00"
  //           ? new Date(new Date(itemAssign.cnd_assignment_end_date).setDate(
  //               new Date(itemAssign.cnd_assignment_end_date).getDate() + 1
  //             ))
  //               .toISOString()
  //               .split("T")[0]
  //           : itemAssign.cnd_assignment_end_date;

  //       const assignmentEndTimeAddMinutes = addMinutes(
  //         assignmentEndTime,
  //         itemAssign.swipe_in_details && itemAssign.cnd_assignment_end_time == "23:30"
  //           ? 29
  //           : itemAssign.swipe_in_details && itemAssign.cnd_assignment_end_time == "23:45"
  //           ? 14
  //           : 30
  //       );
  //       const assignmentEndTimeMinus15 = addMinutes(assignmentEndTime, -15);

  //       // Modified here: Convert times to full Date objects for comparison
  //       const nowDateTime = new Date(`${currentDate}T${currentTime}`);
  //       const startDateTime = new Date(`${assignDateStart}T${assignmentStartTime}`);
  //       const endDateTime = new Date(`${assignDateEnd}T${assignmentEndTime}`);
  //       const endDateTimeExtended = new Date(`${assignDateEnd}T${assignmentEndTimeAddMinutes}`);
  //       const endDateTimeMinus15 = new Date(`${assignDateEnd}T${assignmentEndTimeMinus15}`);

  //       const isOvernightShift = assignmentStartTime > assignmentEndTime;

  //       if (isOvernightShift) {
  //         if (currentDate === assignDateStart && nowDateTime >= startDateTime) {
  //           if (!itemAssign.swipe_in_details) {
  //             isSwipeInVisible = true;
  //             matchedAssignments.push({ ...itemAssign, modalType: "swipe_in" });
  //           }
  //         }

  //         if (currentDate === assignDateEnd) {
  //           if (nowDateTime <= endDateTimeMinus15 && !itemAssign.swipe_in_details) {
  //             isSwipeInVisible = true;
  //             matchedAssignments.push({ ...itemAssign, modalType: "swipe_in" });
  //           }

  //           if (
  //             nowDateTime >= endDateTime &&
  //             nowDateTime <= endDateTimeExtended &&
  //             itemAssign.swipe_in_details &&
  //             (!itemAssign.swipe_out_details || numberOfProperties > 0)
  //           ) {
  //             isSwipeOutVisible = true;
  //             matchedAssignments.push({ ...itemAssign, modalType: "swipe_out" });
  //           }
  //         }
  //       } else {
  //         if (currentDate === assignDateStart && nowDateTime >= startDateTime && nowDateTime <= endDateTimeMinus15) {
  //           if (!itemAssign.swipe_in_details) {
  //             isSwipeInVisible = true;
  //             matchedAssignments.push({ ...itemAssign, modalType: "swipe_in" });
  //           }
  //         }

  //         if (currentDate === assignDateEnd && nowDateTime >= endDateTime && nowDateTime <= endDateTimeExtended) {
  //           if (
  //             itemAssign.swipe_in_details &&
  //             (!itemAssign.swipe_out_details || numberOfProperties > 0)
  //           ) {
  //             isSwipeOutVisible = true;
  //             matchedAssignments.push({ ...itemAssign, modalType: "swipe_out" });
  //           }
  //         }
  //       }
  //     });

  //     if (matchedAssignments.length > 0) {
  //       setCurretAssinmentIndividualData(matchedAssignments);
  //       setShowSwipeInModal(isSwipeOutVisible ? isSwipeOutVisible : isSwipeInVisible);
  //     }

  //     // setShowSwipeInModal(isSwipeOutVisible ? isSwipeOutVisible : isSwipeInVisible);
  //   }
  // };

  // New Function End
  const showSwipeInOrSwipeOutModal = () => {};

  useEffect(() => {
    // Run function immediately
    let getLoggedInData = localStorage.getItem("newLoggedIn");
    const getPageUrl = window.location.pathname;
    if(props.userAuth.users_category === "home care" || props.userAuth.users_category === "home_care" || props.userAuth.users_category === "Home Care"){
      if (myCurrentAssignments.length > 0 && getLoggedInData == "true") {
        localStorage.removeItem("newLoggedIn");
        redirectUrl("/shift-attendance");
      }
      
      if (myCurrentAssignments && getPageUrl != "/shift-attendance") {
        runSwipeInOrSwipeOutModalCall();
  
        // Set interval to run function every 10 minutes (600,000ms)
        const interval = setInterval(() => {
          const parsedData = window.name ? JSON.parse(window.name) : {};
          const lastInsertId = parsedData.lastInsertId || null;
          if (lastInsertId) {
            setShowSwipeInModal(false);
          } else {
            runSwipeInOrSwipeOutModalCall(myCurrentAssignments);
          }
        }, 10000);
  
        // Cleanup interval on component unmount
        return () => clearInterval(interval);
      }
    }
  }, [myCurrentAssignments, props.userAuth.users_category]);
  // Swipe In/out Logic - End

  // For Redirection Method - Start
  useEffect(() => {
    if (props.userData) {
      setUserProfileData(props.userData);
    }

    if (props.progress) {
      setUserProgressBarData(props.progress);
    }
  }, [props.userData, props.progress]);

  // Update Key Information Document - Start
  useEffect(() => {
    if (
      userProfileData.users_role_id == "candidate" &&
      userProfileData.cnd_user_id &&
      userProfileData.job_type != "permanentrequirement"
    ) {
      // Key Information Document - Start
      if (
        !userProfileData.cnd_key_information_document_folder ||
        !userProfileData.cnd_key_information_document_file
      ) {
        dispatch(
          submitDataOnRequest(
            JSON.stringify({ users_id: userProfileData.cnd_user_id }),
            "CreateKeyInformationDocument",
            "",
            [
              getDataOnRequest(
                userProfileData.users_access_token,
                "PersonInfo",
                "SET_USER_DATA",
              ),
            ],
          ),
        )
          .then((response) => {
            if (response.status == "error") {
              // successToast(response.msg);

              errorToast(response.msg);
            }
          })
          .catch((error) => {
            errorToast(error.message);
          });
      }
      // Key Information Document - End

      // Pay & Charge Id Update - Start
      if (
        !userProfileData.user_signed_pay_rates_and_job_titles_ids &&
        userProfileData.user_sign_signature
      ) {
        dispatch(
          submitDataOnRequest(
            JSON.stringify({ users_id: userProfileData.cnd_user_id }),
            "UpdatePayChargeRateForAlreadySignedContracts",
            "",
            [
              // getDataOnRequest(userProfileData.users_access_token,'SetWorkPrefrences','SET_WORK_PREFRENCES'),
            ],
          ),
        )
          .then((response) => {
            if (response.status == "error") {
              errorToast(response.msg);
            }
          })
          .catch((error) => {
            errorToast(error.message);
          });
      }
      // Pay & Charge Id Update - End
    }
  }, [userProfileData]);
  // Update Key Information Document - End

  useEffect(() => {
    const urlNotDirectArray = [
      "/contact-us",
      "/job-profile",
      "/work-prefrences",
      "/flt-license",
      "/driver-details",
      "/employment-and-professional-references",
      "/type-of-services",
      "/bank-details",
      "/create-right-to-work",
      "/right-to-work",
      "/create-document-address1",
      "/create-document-address2",
      "/create-document-update-address",
      "/create-document-national-insurance",
      "/create-document-police-clearnace-certificate",
      "/create-document-training-certificate",
      "/create-document-additional",
      "/document-required",
      "/dbs-document",
      "/dbs-applied-document",
      "/create-dbs-document",
      "/create-identity-document",
      "/identity-document",
      "/agreements",
      "/key-information-document",
      "/sign-contract",
      "/delete-account",
      "/delete-account-otp-verification",
    ];
    if (
      Object.keys(userProfileData).length > 0 &&
      Object.keys(userProgressBarData).length > 0 &&
      userProfileData?.job_type !== "permanentrequirement" &&
      currentActiveLocation &&
      currentActiveLocation != getLocationSession &&
      !urlNotDirectArray.some((url) => currentActiveLocation.startsWith(url))
    ) {
      let checkRed = "0";
      let urlRed = "";
      let profileComponentName = "";

      if (
        userProfileData?.users_firstname &&
        !userProfileData?.user_sign_signature
      ) {
        if (
          userProgressBarData?.progress_bar_profile_1 &&
          userProgressBarData?.progress_bar_profile_1 !== "1"
        ) {
          checkRed = "1";
          urlRed = "/job-profile";
          profileComponentName = "My Profile";
        } else if (
          userProgressBarData?.progress_bar_work_preference_6 !== "1"
        ) {
          checkRed = "1";
          urlRed = "/work-prefrences";
          profileComponentName = "Work Preferences";
        } else if (
          userProgressBarData?.fltLicense === "true" &&
          userProgressBarData?.cnd_flt_licenses_progress_bar !== "1"
        ) {
          checkRed = "1";
          urlRed = "/flt-license";
          profileComponentName = "FLT License";
        } else if (
          userProgressBarData?.driverDetails === "true" &&
          userProgressBarData?.cnd_driver_details_progress_bar !== "1"
        ) {
          checkRed = "1";
          urlRed = "/driver-details";
          profileComponentName = "Driver Details";
        } else if (userProgressBarData?.progress_bar_reference_2 !== "1") {
          checkRed = "1";
          urlRed = "/employment-and-professional-references";
          profileComponentName = "Employment and professional reference";
        } else if (
          userProfileData?.users_category &&
          jobSectorInvertList[userProfileData?.users_category] ===
            "home care" &&
          (!userProfileData?.cnd_types_of_services ||
            userProfileData?.cnd_types_of_services == "")
        ) {
          checkRed = "1";
          urlRed = "/type-of-services";
          profileComponentName = "Type of Services";
        } else if (userProgressBarData?.progress_bar_bank_4 !== "1") {
          checkRed = "1";
          urlRed = "/bank-details";
          profileComponentName = "Bank Details";
        } else if (userProgressBarData?.progress_bar_right_to_work_5 !== "1") {
          checkRed = "1";
          urlRed = "/create-right-to-work";
          profileComponentName = "Right To Work";
        } else if (userProgressBarData?.progress_bar_compliance_7 !== "1") {
          checkRed = "1";
          if (!userProgressBarData?.cnd_compliance_doc_master_id) {
            urlRed = "/create-document-address1";
          } else if (
            userProgressBarData?.cnd_compliance_doc_master_id === "address1"
          ) {
            urlRed = "/create-document-address2";
          } else if (
            userProgressBarData?.cnd_compliance_doc_master_id === "address2"
          ) {
            urlRed = "/create-document-national-insurance";
          } else if (
            userProgressBarData?.cnd_compliance_doc_master_id &&
            userProgressBarData?.cnd_compliance_doc_master_id ==
              "nationalinsurance"
          ) {
            urlRed = "/create-document-police-clearnace-certificate";
          } else {
            urlRed = "/document-required";
          }
          profileComponentName = "Documents Required";
        } else if (userProgressBarData?.dbsDetailsParam !== "true") {
          checkRed = "1";
          urlRed = "/create-dbs-document";
          profileComponentName = "DBS Certificate";
        } else if (userProgressBarData.progress_bar_identity_9 !== "1") {
          checkRed = "1";
          urlRed = "/create-identity-document";
          profileComponentName = "Identity Documents";
        } else if (userProgressBarData.progress_bar_agreement_3 !== "1") {
          checkRed = "1";
          urlRed = "/agreements";
          profileComponentName = "Agreements";
        } else {
          checkRed = "1";
          urlRed = "/sign-contract";
          profileComponentName = "Sign Contract";
        }

        Swal.fire({
          title: "Please, complete your profile",
          icon: "warning",
          text: `Hey ${userProfileData?.users_firstname}, please complete "${profileComponentName}", you have to complete 100% of your profile and sign the contract to proceed further!`,
          timer:
            window.location.host === "www.staffingconnect.co.uk" ||
            window.location.host === "staffingconnect.co.uk"
              ? false
              : false, //5000,
          timerProgressBar: true,
          dangerMode: true,
          showCancelButton: false,
          showDenyButton: false,
          confirmButtonText: "Ok",
          closeOnClickOutside: false,
          didClose: () => {
            if (checkRed === "1") {
              localStorage.setItem("redirectPathLocation", urlRed);
              let setSessionOfLocation = localStorage.getItem(
                "redirectPathLocation",
              );
              if (setSessionOfLocation) {
                window.location.href = urlRed;
              }
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem("redirectPathLocation", urlRed);
            let setSessionOfLocation = localStorage.getItem(
              "redirectPathLocation",
            );
            if (setSessionOfLocation) {
              window.location.href = urlRed;
            }
          }
        });
      }
    }
  }, [userProfileData, userProgressBarData]);
  // For Redirection Method - End

  // Job Search Details Removed - Start
  useEffect(() => {
    if (typeof window !== "undefined") {
      const path = window.location.pathname;
      const hasApplyJobDetails = localStorage.getItem("applyJobDetails");

      const isJobBoard = path.includes("/job-board");
      const isJobDetails = path.includes("/job-details");

      if (!isJobBoard && !isJobDetails && !hasApplyJobDetails) {
        localStorage.removeItem("searchBarDetails");
        localStorage.removeItem("jobSearchDetails");
      }
    }
  }, []);
  // Job Search Details Removed - End

  return (
    <React.Fragment>
      {/* Swipe In Modal Start */}
      {showSwipeInModal == true && (
        <SwipeInModal
          curretAssinmentIndividualData={curretAssinmentIndividualData}
          showSwipeInModal={showSwipeInModal}
          setShowSwipeInModal={setShowSwipeInModal}
          deviceInfo={checkDevice}
        />
      )}

      {/* {showSwipeOutModal == true && (
        <SwipeOutModal
          curretAssinmentIndividualData={curretAssinmentIndividualData}
          showSwipeOutModal={showSwipeOutModal}
          setShowSwipeOutModal={setShowSwipeOutModal}
        />
      )} */}
      {/* Swipe In Modal End */}
      {/* <div className="container-fluid bg-dark px-5 d-none d-lg-block sticky-top toop-bar">
        <div className="row">
            <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
                <div className="d-inline-flex align-items-center" style={{height: "45px"}}>
                    <small className="me-3 text-light"><i className="fa fa fa-phone me-2"></i>Hounslow: 0203 841 6440</small>
                    <small className="me-3 text-light"><i className="fa fa fa-phone me-2"></i>Out of office hours: 07508098567</small>
                    <small className="text-light"><i className="fa fa-envelope-open me-2"></i>info@example.com</small>
                </div>
            </div>
        </div>
    </div> */}
      <nav className="site-header mo-left header fullwidth is-fixed">
        <div className="sticky-header main-bar-wraper navbar-expand-lg">
          <div className="main-bar clearfix ">
            <div className="row bg-dark toop-bar">
              <div className="col-12 text-center text-lg-start mb-2 mb-lg-0">
                <div
                  className="d-inline-flex float-right"
                  style={{ height: "45px" }}
                >
                  <small className="text-light">
                    <i className="fa fa fa-phone me-2"></i>
                    <a href="tel:0203 841 6440" className="text-light">
                      {" "}
                      Hounslow: 0203 841 6440
                    </a>
                  </small>
                  <small className="ml-5 mr-1 text-light">
                    <i className="fa fa fa-phone me-2"></i>{" "}
                    <a href="tel:07508098567" className="text-light">
                      {" "}
                      Out of office hours: 07508098567
                    </a>
                  </small>
                  {/* <small className="text-light"><i className="fa fa-envelope-open me-2"></i>info@example.com</small> */}
                </div>
              </div>
            </div>

            {/* <h6 className="float-end  mt-5">Ph: 0203 841 6440</h6> */}
            <div className="container clearfix">
              <div className="logo-header mostion">
                <a href={"/"}>
                  <img
                    src={logo2}
                    className="logo m-t10"
                    style={{ height: "4rem" }}
                    alt="img"
                  />
                </a>
              </div>

              <a
                className={
                  "navbar-toggler navicon justify-content-center " +
                  (!props.userData.users_profile_pic && props.userAuth.user_name
                    ? "bg-dark border border-success border-5 pt-0"
                    : "")
                }
                style={{
                  width:
                    props.userData.users_profile_pic || props.userAuth.user_name
                      ? "40px"
                      : "",
                  height:
                    props.userData.users_profile_pic || props.userAuth.user_name
                      ? "40px"
                      : "",
                  borderRadius:
                    !props.userData.users_profile_pic &&
                    props.userAuth.user_name
                      ? "20px"
                      : "",
                  border:
                    !props.userData.users_profile_pic &&
                    props.userAuth.user_name
                      ? "3px"
                      : "",
                }}
                id="navbar_drawer"
                onClick={(event) => {
                  if (navBarOpen == false) {
                    setNavBarOpen(true);
                  } else {
                    setNavBarOpen(false);
                  }
                }}
              >
                {!props.userData.users_profile_pic &&
                !props.userAuth.user_name &&
                profilePic == false ? (
                  <>
                    <span />
                    <span />
                    <span />
                    <span />
                  </>
                ) : props.userData.users_profile_img_path &&
                  props.userData.users_profile_pic ? (
                  <>
                    {profilePic == false && (
                      <>
                        <span />
                        <span />
                        <span />
                      </>
                    )}
                    <img
                      className={
                        "size-thumbnail1 rounded-circle cursor-pointer " +
                        (profilePic == true
                          ? "border border-success border-5"
                          : "")
                      }
                      ref={imageRef}
                      onLoad={(event) => {
                        setProfilePic(true);
                      }}
                      src={
                        constants.IMAGE_URL +
                        props.userData.users_profile_img_path +
                        props.userData.users_profile_pic
                      }
                    />
                  </>
                ) : (
                  <div className="text-white text-center">
                    <h6 className="p-2">
                      {props.userAuth.user_name &&
                      getInitialsLettersOfString(props.userAuth.user_name) &&
                      getInitialsLettersOfString(props.userAuth.user_name) !=
                        "UU" ? (
                        getInitialsLettersOfString(props.userAuth.user_name)
                      ) : (
                        <>
                          <span />
                          <span />
                          <span />
                          <span />
                        </>
                      )}
                    </h6>
                  </div>
                )}
              </a>
              <div className="extra-nav">
                <div className="extra-cell">
                  {((!props.isAuthenticated && pageName != "/login") ||
                    pageName == "/") && (
                    <Login onClick={(page) => onClick(page)} />
                  )}
                  {((!props.isAuthenticated && pageName != "/register") ||
                    pageName == "/") && (
                    <Signup onClick={(page) => onClick(page)} />
                  )}
                  {props.isAuthenticated && <Logout />}
                </div>
              </div>

              <div
                className="header-nav navbar-expand expand myNavbar justify-content-start"
                id="navbarNavDropdown"
                // onMouseOut={(event) => {
                //   let navbar_drawer =  document.getElementById('navbar_drawer');
                //   if(navbar_drawer){
                //     navbar_drawer.click();
                //   }
                // }}
              >
                <div className="logo-header mostion d-md-block d-lg-none">
                  <a href="#" onClick={() => onClick("/")} className="dez-page">
                    <img src={logo2} alt="" />
                  </a>
                </div>
                <ul className="nav navbar-nav" style={{ height: "100%" }}>
                  <li>
                    {userType ? (
                      <>
                        {userType == "permanentrequirement" ? (
                          <a href={"/candidate-profile"}>Profile & CV</a>
                        ) : (
                          <>
                            {props.userData.cnd_profile_is_temping ==
                            "Allowed" ? (
                              <a href="/dashboard">Dashboard</a>
                            ) : (
                              // <a href={"/candidate-profile"}>Profile & CV</a>
                              <a href="/dashboard">Dashboard</a>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <a href="/">Home</a>
                    )}
                  </li>
                  {!userType && (
                    <li>
                      <a href="/about-us">About Us</a>
                    </li>
                  )}
                  <li>
                    <a href="/job-board" onClick={() => onClick("#")}>
                      Job Board {/*<i className="fa fa-chevron-down"></i>*/}
                    </a>
                    {/* <ul className="sub-menu">
                      <li>
                        <a href={"/permanent-jobs"} className="dez-page">
                          Permanent Job
                        </a>
                      </li>
                      <li>
                        <a href={"/temporary-jobs"} className="dez-page">
                          Temporary Jobs
                        </a>
                      </li>
                    </ul> */}
                  </li>

                  {!userType && (
                    <li>
                      <a href={"#"}>
                        Our Services <i className="fa fa-chevron-down"></i>
                      </a>
                      <ul className="sub-menu">
                        <li>
                          <a href={"#"} className="dez-page">
                            Education <i className="fa fa-angle-right"></i>
                          </a>
                          <ul className="sub-menu">
                            <li>
                              <a href={"/nursery"} className="dez-page">
                                Nursery{" "}
                              </a>
                            </li>
                            <li>
                              <a href={"/primary"} className="dez-page">
                                Primary{" "}
                              </a>
                            </li>
                            <li>
                              <a href={"/secondary"} className="dez-page">
                                Secondary{" "}
                              </a>
                            </li>
                            <li>
                              <a
                                href={"/special-education"}
                                className="dez-page"
                              >
                                Special Education{" "}
                              </a>
                            </li>
                            <li>
                              <a
                                href={"/further-education"}
                                className="dez-page"
                              >
                                Further Education{" "}
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href={"#"} className="dez-page">
                            Home Care <i className="fa fa-angle-right"></i>
                          </a>
                          <ul className="sub-menu">
                            <li>
                              <a
                                href={"/care-in-your-home"}
                                className="dez-page"
                              >
                                {" "}
                                Care in your home{" "}
                              </a>
                            </li>
                            <li>
                              <a href={"/live-in-care"} className="dez-page">
                                {" "}
                                Live in Care{" "}
                              </a>
                            </li>
                            <li>
                              <a
                                href={"/learning-disabilities-support"}
                                className="dez-page"
                              >
                                Learning Disabilities Support{" "}
                              </a>
                            </li>
                            <li>
                              <a
                                href={"/physical-disabilities-support"}
                                className="dez-page"
                              >
                                Physical Disabilities Support{" "}
                              </a>
                            </li>
                            <li>
                              <a
                                href={"/reablement-services"}
                                className="dez-page"
                              >
                                Reablement Services{" "}
                              </a>
                            </li>
                            <li>
                              <a href={"/respite-care"} className="dez-page">
                                Respite Care{" "}
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href={"#"} className="dez-page">
                            Social Care <i className="fa fa-angle-right"></i>
                          </a>
                          <ul className="sub-menu">
                            <li>
                              <a
                                href={"/childrens-residential"}
                                className="dez-page"
                              >
                                Children’s Residential{" "}
                              </a>
                            </li>
                            {/* <li><a href={"#"} className="dez-page">Elderly Residential  </a></li> */}
                            <li>
                              <a
                                href={"/learning-disability-day-centres"}
                                className="dez-page"
                              >
                                Learning Disability Day centres{" "}
                              </a>
                            </li>
                            <li>
                              <a
                                href={"/childrens-learning-disability-respites"}
                                className="dez-page"
                              >
                                Children's Learning Disability Respites{" "}
                              </a>
                            </li>
                            <li>
                              <a
                                href={"/elderly-care-services"}
                                className="dez-page"
                              >
                                Elderly Care Services{" "}
                              </a>
                            </li>
                            {/* <li><a href={"#"} className="dez-page">Semi Independent Living  </a></li> */}
                          </ul>
                        </li>
                        <li>
                          <a href={"/industrial"} className="dez-page">
                            Industrial
                          </a>
                        </li>
                        <li>
                          <a href={"/commercial"} className="dez-page">
                            Commercial
                          </a>
                        </li>
                        <li>
                          <a
                            href={"/information-technology"}
                            className="dez-page"
                          >
                            Information Technology
                          </a>
                        </li>
                        <li>
                          <a
                            href={"/accounting-and-finance"}
                            className="dez-page"
                          >
                            Accounting & Finance
                          </a>
                        </li>
                      </ul>
                    </li>
                  )}

                  {userType && (
                    <li>
                      <a href={"/applied-jobs"}>Jobs Applied</a>
                    </li>
                  )}

                  <li>
                    <a href="/contact-us">Contact Us</a>
                  </li>
                  {/* {userType && (
                    <li>
                      <a href={"/account-faq"}>Account Centre</a>
                    </li>
                  )} */}
                  {/* <ul className="nav  navbar-nav"> */}
                  {/* My Account Common Start */}
                  {props.isAuthenticated && (
                    <>
                      {roleId == "candidate" ? (
                        ""
                      ) : (
                        <li>
                          <a>
                            <i
                              className="fa fa-spinner text-center fa-pulse text-primary"
                              style={{ fontSize: "200%" }}
                            ></i>
                          </a>
                        </li>
                      )}
                    </>
                  )}
                  {checkDevice == "Mobile" ? (
                    <>
                      <li
                        style={{
                          display:
                            props.isAuthenticated && roleId == "candidate"
                              ? "block"
                              : "none",
                        }}
                        className="bg-primary"
                      >
                        <a
                          href="/candidate-profile"
                          className="bg-primary text-white"
                          style={{ border: "none" }}
                        >
                          <i
                            className="fa fa-user-circle-o text-left"
                            style={{ fontSize: "100%" }}
                          ></i>
                          My Account
                          {/* {props.userAuth.user_name}{" "} */}
                          {/* <i className="fa fa-chevron-down text-white"></i> */}
                        </a>
                        <ul className="sub-menu" style={{ display: "none" }}>
                          {/* <li>
                        <a href={"/candidate-profile"} className="dez-page">
                          Profile & CV
                        </a>
                      </li> */}
                          {/* <li>
                        <a href={userType == "permanentrequirement" ? "/permanent-candidate-dashboard" : "/dashboard"}>Dashboard</a>
                      </li> */}
                          {/* {userType != "permanentrequirement" && props.userData.cnd_profile_is_temping == "Allowed" && (
                        <>
                          <li>
                            <a href={userType == "permanentrequirement" ? "/permanent-candidate-dashboard" : "/dashboard"}>Temping</a>
                          </li>                        
                        </>
                      )} */}
                          {/* <li>
                            <a href={"/applied-jobs"}>Jobs Applied</a>
                          </li> */}
                          {/* <li>
                        <a href={"/change-password"} className="dez-page">
                          Change Password
                        </a>
                      </li> */}
                          <li>
                            <a href={"/account-faq"} className="dez-page">
                              Account Centre
                            </a>
                          </li>
                        </ul>
                      </li>
                    </>
                  ) : (
                    <>
                      <li
                        style={{
                          display:
                            props.isAuthenticated && roleId == "candidate"
                              ? "block"
                              : "none",
                        }}
                      >
                        <a
                          href="/candidate-profile"
                          className="bg-primary text-white p-2 mt-3"
                          style={{
                            borderRadius: "20px",
                            textTransform: "capitalize",
                          }}
                        >
                          <i
                            className="fa fa-user-circle-o mr-2"
                            style={{ fontSize: "100%" }}
                          ></i>
                          {/* {props.userAuth.user_name}{" "} */}
                          My Account
                          {/* <i className="fa fa-chevron-down text-white"></i> */}
                        </a>
                        <ul className="sub-menu" style={{ display: "none" }}>
                          {/* <li>
                        <a href={"/candidate-profile"} className="dez-page">
                          Profile & CV
                        </a>
                      </li> */}
                          {/* <li>
                        <a href={userType == "permanentrequirement" ? "/permanent-candidate-dashboard" : "/dashboard"}>Dashboard</a>
                      </li> */}
                          {/* {userType != "permanentrequirement" && props.userData.cnd_profile_is_temping == "Allowed" && (
                        <>
                          <li>
                            <a href={userType == "permanentrequirement" ? "/permanent-candidate-dashboard" : "/dashboard"}>Temping</a>
                          </li>                        
                        </>
                      )} */}
                          {/* <li>
                            <a href={"/applied-jobs"}>Jobs Applied</a>
                          </li> */}
                          {/* <li>
                        <a href={"/change-password"} className="dez-page">
                          Change Password
                        </a>
                      </li> */}
                          <li>
                            <a href={"/account-faq"} className="dez-page">
                              Account Centre
                            </a>
                          </li>
                        </ul>
                      </li>
                    </>
                  )}
                  {/* My Account Common End */}
                  {props.isAuthenticated && roleId == "client" && (
                    <li>
                      <a href="/client-dashboard">My Account</a>
                    </li>
                  )}
                  {props.isAuthenticated && (
                    <li className="d-block d-md-none">
                      <a href="#" onClick={() => onLogout()}>
                        Logout
                      </a>
                    </li>
                  )}
                  {!props.isAuthenticated && (
                    <li className="d-block d-md-none">
                      <a href="/login" onClick={(page) => onClick(page)}>
                        Login
                      </a>
                    </li>
                  )}
                  {!props.isAuthenticated && (
                    <li className="d-block d-md-none">
                      <a href="/register" onClick={(page) => onClick(page)}>
                        Signup
                      </a>
                    </li>
                  )}
                  {/* </ul> */}

                  {/* <li>
                    <a href={"#"}>
                      For Employers <i className="fa fa-chevron-down" />
                    </a>
                    <ul className="sub-menu">
                      <li>
                        <a href={"/company-profile"} className="dez-page">
                          Company Profile <span className="new-page">New</span>
                        </a>
                      </li>
                    </ul>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* {console.log("All User Data :=> "+JSON.stringify(props.userAuth.users_category))} */}
      </nav>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
    userAuth: state.auth.authUserData,
    userData: state.userProfile.userData,
    myCurrentRunningAssignments:
      state.myCurrentRunningAssignments.myCurrentRunningAssignments,
    progress: state.progress.progress,
  };
};

export default connect(mapStateToProps)(PageHeader);
